// tooltipMessages.js

export const TOOLTIP_MESSAGES = {
  email: "Enter a valid admin email. Example: admin@fliplyn.com",
  password: "Password must be at least 8 characters. Eye icon toggles visibility.",
  remember: "Saves login on this device only.",
  forgot: "Opens password recovery flow.",
  login: "Disabled until email is filled and password is at least 8 characters.",
};
